var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { style: { backgroundColor: _vm.$themeTokens.surface } },
    [
      _c(
        "h3",
        { staticClass: "header", attrs: { id: "answer-history-label" } },
        [_vm._v("\n    " + _vm._s(_vm.$tr("answerHistoryLabel")) + "\n  ")]
      ),
      _vm.isMobile
        ? _c(
            "div",
            [
              _vm.sectionSelectOptions.length > 1
                ? _c("KSelect", {
                    staticClass: "section-select",
                    attrs: {
                      value: _vm.selectedSection,
                      label: _vm.quizSectionsLabel$(),
                      options: _vm.sectionSelectOptions,
                      disabled: _vm.$attrs.disabled,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleSectionChange($event.value)
                      },
                    },
                  })
                : _vm.selectedSection.label
                ? _c("h2", { staticClass: "section-select" }, [
                    _vm._v(
                      "\n      " + _vm._s(_vm.selectedSection.label) + "\n    "
                    ),
                  ])
                : _vm._e(),
              _c("KSelect", {
                staticClass: "history-select",
                attrs: {
                  value: _vm.selectedQuestion,
                  label: _vm.questionsLabel$(),
                  options: _vm.questionSelectOptions,
                  disabled: _vm.$attrs.disabled,
                },
                on: {
                  change: function ($event) {
                    return _vm.handleQuestionChange($event.value)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display",
                      fn: function () {
                        return [
                          _c("AttemptLogItem", {
                            staticClass: "attempt-selected",
                            attrs: {
                              isSurvey: _vm.isSurvey,
                              attemptLog: _vm.selectedAttemptLog,
                              questionNumber: _vm.selectedQuestionNumber + 1,
                              displayTag: "span",
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "option",
                      fn: function ({ index }) {
                        return [
                          _vm.attemptLogsForCurrentSection[index]
                            ? _c("AttemptLogItem", {
                                staticClass: "attempt-option",
                                attrs: {
                                  isSurvey: _vm.isSurvey,
                                  attemptLog:
                                    _vm.attemptLogsForCurrentSection[index],
                                  questionNumber: index + 1,
                                  displayTag: "span",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  943363403
                ),
              }),
            ],
            1
          )
        : _c(
            "AccordionContainer",
            { attrs: { hideTopActions: true, items: _vm.sections } },
            _vm._l(_vm.sections, function (section, index) {
              return _c("AccordionItem", {
                key: `section-questions-${index}`,
                attrs: {
                  id: `section-questions-${index}`,
                  title: _vm.displaySectionTitle(section, index),
                },
                on: {
                  focus: function ($event) {
                    return _vm.expand(index)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    _vm.sections.length > 1
                      ? {
                          key: "heading",
                          fn: function ({ title }) {
                            return [
                              title
                                ? _c(
                                    "h3",
                                    {
                                      staticClass: "accordion-header",
                                      style: {
                                        backgroundColor:
                                          index === _vm.currentSectionIndex
                                            ? _vm.$themePalette.grey.v_200
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "KButton",
                                        {
                                          staticClass: "accordion-header-label",
                                          style: _vm.accordionStyleOverrides,
                                          attrs: {
                                            tabindex: "0",
                                            appearance: "basic-link",
                                            "aria-expanded":
                                              _vm.isExpanded(index),
                                            "aria-controls": `section-question-panel-${index}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggle(index)
                                            },
                                          },
                                        },
                                        [
                                          _c("span", [_vm._v(_vm._s(title))]),
                                          _c("KIcon", {
                                            staticClass: "chevron-icon",
                                            attrs: {
                                              icon: _vm.isExpanded(index)
                                                ? "chevronUp"
                                                : "chevronRight",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          },
                        }
                      : null,
                    {
                      key: "content",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.sections.length === 1 ||
                                    _vm.isExpanded(index),
                                  expression:
                                    "sections.length === 1 || isExpanded(index)",
                                },
                              ],
                            },
                            [
                              _c(
                                "ul",
                                {
                                  ref: "attemptList",
                                  refInFor: true,
                                  staticClass: "history-list",
                                  attrs: { role: "listbox" },
                                  on: {
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "home",
                                            undefined,
                                            $event.key,
                                            undefined
                                          )
                                        )
                                          return null
                                        return _vm.setSelectedAttemptLog(0)
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "end",
                                            undefined,
                                            $event.key,
                                            undefined
                                          )
                                        )
                                          return null
                                        return _vm.setSelectedAttemptLog(
                                          _vm.attemptLogs.length - 1
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "up",
                                            38,
                                            $event.key,
                                            ["Up", "ArrowUp"]
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        _vm.setSelectedAttemptLog(
                                          _vm.previousQuestion(
                                            _vm.selectedQuestionNumber
                                          )
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "left",
                                            37,
                                            $event.key,
                                            ["Left", "ArrowLeft"]
                                          )
                                        )
                                          return null
                                        if (
                                          "button" in $event &&
                                          $event.button !== 0
                                        )
                                          return null
                                        $event.preventDefault()
                                        _vm.setSelectedAttemptLog(
                                          _vm.previousQuestion(
                                            _vm.selectedQuestionNumber
                                          )
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "down",
                                            40,
                                            $event.key,
                                            ["Down", "ArrowDown"]
                                          )
                                        )
                                          return null
                                        $event.preventDefault()
                                        _vm.setSelectedAttemptLog(
                                          _vm.nextQuestion(
                                            _vm.selectedQuestionNumber
                                          )
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "right",
                                            39,
                                            $event.key,
                                            ["Right", "ArrowRight"]
                                          )
                                        )
                                          return null
                                        if (
                                          "button" in $event &&
                                          $event.button !== 2
                                        )
                                          return null
                                        $event.preventDefault()
                                        _vm.setSelectedAttemptLog(
                                          _vm.nextQuestion(
                                            _vm.selectedQuestionNumber
                                          )
                                        )
                                      },
                                    ],
                                  },
                                },
                                _vm._l(
                                  section.questions,
                                  function (question, qIndex) {
                                    return _c(
                                      "li",
                                      {
                                        key: `attempt-item-${qIndex}`,
                                        staticClass: "attempt-item",
                                        style: {
                                          backgroundColor: _vm.isSelected(
                                            section.startQuestionNumber + qIndex
                                          )
                                            ? _vm.$themePalette.grey.v_200
                                            : "",
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            ref: "attemptListOption",
                                            refInFor: true,
                                            staticClass: "attempt-item-anchor",
                                            attrs: {
                                              role: "option",
                                              "aria-selected": _vm
                                                .isSelected(
                                                  section.startQuestionNumber +
                                                    qIndex
                                                )
                                                .toString(),
                                              tabindex: _vm.isSelected(
                                                section.startQuestionNumber +
                                                  qIndex
                                              )
                                                ? 0
                                                : -1,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.setSelectedAttemptLog(
                                                  section.startQuestionNumber +
                                                    qIndex
                                                )
                                              },
                                              keydown: [
                                                function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  )
                                                    return null
                                                  return _vm.setSelectedAttemptLog(
                                                    section.startQuestionNumber +
                                                      qIndex
                                                  )
                                                },
                                                function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "space",
                                                      32,
                                                      $event.key,
                                                      [" ", "Spacebar"]
                                                    )
                                                  )
                                                    return null
                                                  $event.preventDefault()
                                                  return _vm.setSelectedAttemptLog(
                                                    section.startQuestionNumber +
                                                      qIndex
                                                  )
                                                },
                                              ],
                                            },
                                          },
                                          [
                                            _vm.attemptLogsBySection[index][
                                              qIndex
                                            ]
                                              ? _c("AttemptLogItem", {
                                                  attrs: {
                                                    isSurvey: _vm.isSurvey,
                                                    attemptLog:
                                                      _vm.attemptLogsBySection[
                                                        index
                                                      ][qIndex],
                                                    questionNumber: qIndex + 1,
                                                    displayTag: "p",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }